import { BetBuilderEventType } from "app/types/betBuilderType";
import { BetSlipType } from "app/types/betSlipType";
import { get } from "lodash";
import BetBuilderItem from "../BetBuilderItem/BetBuilderItem";
import "./BetBuilderItems.scss";

type props = {
  items: BetSlipType[];
  betBuilderEvent: BetBuilderEventType;
};

const BetBuilderItems: React.FC<props> = ({ items, betBuilderEvent }) => {
  return (
    <div className={`bet-builder-items`}>
      {items.map((item, index) => {
        const runnerId = get(item, ["markets", 0, "runners", 0, "id"]) || "";

        return (
          <BetBuilderItem
            overallStatus={betBuilderEvent?.errorMessage}
            selections={betBuilderEvent?.selections}
            key={runnerId}
            item={item}
            index={index}
            numberOfItems={items.length}
          />
        );
      })}
    </div>
  );
};

export default BetBuilderItems;
